import { createAsyncThunk } from "@reduxjs/toolkit";
import setBaseURL from "../libs/utilities/helpers/BaseURLHelper";
import { api } from "./config/axiosConfig";
import { encryptData, decryptData } from "../libs/utilities/helpers/Crypto";


//getAPi config means path , environment variables , endpoints such as
const getAPIConfig = (serviceId) => {
    if (!serviceId) return null;
    const envVarName = `REACT_APP_BASE_URL_GPT`;
    const apiPath = serviceId;    
    return {
        baseURL: process.env[envVarName], 
        list: `/gpt/${apiPath}/list/`,
        conversation: `/gpt/${apiPath}/conversation`,
        feedback: `/gpt/${apiPath}/feedback`,
        download:`/gpt/${apiPath}/file`,
        promptLibrary:`/gpt/${apiPath}/prompt/library`

    };
};

export class ChatBotTemplateAPI {
    getPdf = createAsyncThunk(
        "",
        async ({ serviceId, ...data }) => {
            try {
                const { baseURL, download } = getAPIConfig(serviceId);
                setBaseURL(api, baseURL);
                // const response = await api.post(`${list}${data.fileName}`,{folder_name: data.folderName});
                //as per new api changes  
                // const encrypted =  encryptData(JSON.stringify(data.fileId));  
                let response = await api.get(`${download}?fileId=${data.fileId}`);
                const decrypted =  decryptData(response.data.data);
              const parsed = JSON.parse(decrypted);
              response = {data:parsed}
                return response.data;
            } catch (error) {
                throw error;
            }
        }
    );
    generateAnswer = createAsyncThunk(
        "",
        async ({ serviceId, ...data }, { rejectWithValue }) => {
            try {
                const { baseURL, conversation } = getAPIConfig(serviceId);
                setBaseURL(api, baseURL);
                const encrypted =  encryptData(JSON.stringify(data));
                let response = await api.post(conversation, encrypted);
                 const decrypted =  decryptData(response.data.data);
              const parsed = JSON.parse(decrypted);
              response = {data:parsed}
                return response.data;
            } catch (error) {
                return rejectWithValue(error.response.data);
            }
        }
    );

    saveFeedback = createAsyncThunk(
        "",
        async ({ serviceId, ...data }, { rejectWithValue }) => {
            try {
                const { baseURL, feedback } = getAPIConfig(serviceId);
                setBaseURL(api, baseURL);
                const encrypted =  encryptData(JSON.stringify(data));
                let response = await api.post(feedback, encrypted);
                 const decrypted =  decryptData(response.data.data);
              const parsed = JSON.parse(decrypted);
              response = {data:parsed}
                return response.data;
            } catch (error) {
                return rejectWithValue(error.message);
            }
        }
    )
 
    getPromptLibrary = createAsyncThunk(
        "",
        async ({ serviceId, ...data }, { rejectWithValue }) => {
            try {
                const { baseURL, promptLibrary } = getAPIConfig(serviceId);
                setBaseURL(api, baseURL);
                let response = await api.get(promptLibrary);
                 const decrypted =  decryptData(response.data.data);
              const parsed = JSON.parse(decrypted);
              response = {data:parsed}
                return response.data;
            } catch (error) {
                return rejectWithValue(error.message);
            }
        }
    )

}
